import React from 'react'

type Props = {
  id?: string
  name?: string
}

/**
 * Ustawia tytuł karty na nazwę firmy.
 *
 * Wcześniej robiło to dwa razy: przez `useEffect` i przez `<Helmet>` z `react-helmet`.
 * Paczka nie ma wydania od 2020 i nic tu nie wnosiła, więc został sam efekt.
 */
export const CompanyMeta = ({ id, name }: Props) => {
  const title = name ? `${name}` : id ? 'EasyTacho ' + id : 'EasyTacho'

  React.useEffect(() => {
    document.title = title
  }, [title])

  return null
}
